<template>
  <div class="header-block">
    <h2>{{ title }}</h2>
    <p>{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "custom-title-block",
  props: {
    title: {
      type: String,
      default: () => "",
    },
    subtitle: {
      type: String,
      default: () => "",
    },
  },
};
</script>

<style lang="scss" scoped>
.header-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 44px;

  @media (max-width: 767px) {
    margin-bottom: 24px;
    gap: 34px;
  }

  h2 {
    font-family: "UAF Sans H", serif;
    font-weight: 700;
    font-size: 32px;
    line-height: 36px;
    text-transform: uppercase;
    max-width: 390px;

    @media (max-width: 767px) {
      font-size: 28px;
      line-height: 32px;
    }
  }

  p {
    font-family: "UAF Sans H", serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-transform: uppercase;
    max-width: 541px;

    @media (max-width: 767px) {
      line-height: 16px;
      font-size: 12px;
    }
  }
}

.grc {
  h2 {
    max-width: 900px;
  }
}
</style>
